import { Pipe, PipeTransform } from '@angular/core';
import {
  EmployeeHistoryEnum,
  EmployeeHistoryInfo,
} from '@qaroni-app/employee/types/employee-history.enum';

@Pipe({
  name: 'employeeHistory',
  standalone: false,
})
export class EmployeeHistoryPipe implements PipeTransform {
  transform(value: EmployeeHistoryEnum): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(EmployeeHistoryInfo, value)
    ) {
      return EmployeeHistoryInfo[value].name;
    }

    return value;
  }
}
